import React, { useState } from "react"
import { Button, InputNumber, Popover, message } from "antd"
import { EditOutlined } from "@ant-design/icons"
import { useQueryClient } from "@tanstack/react-query"
import i18n from "../../services/i18n"
import normalizeCurrency from "../../utils/normalizeCurrency"
import { permSync } from "../../utils/permSync"
import { SET_TRANSFER_PRICE } from "./mutations"

// tog'a #2888 (2026-09-26): perevod narxlari. Eski perevodlarda nusxa yo'q — tovarning joriy sotuv narxi ko'rsatiladi.
export function narxlar(r: any): { sale: number | null; transfer: number | null } {
  const sale = r?.salePriceUSD != null ? Number(r.salePriceUSD) : r?.mainProduct?.salePriceUSD != null ? Number(r.mainProduct.salePriceUSD) : null
  const transfer = r?.transferPriceUSD != null ? Number(r.transferPriceUSD) : sale
  return { sale, transfer }
}

/** «Цена перевода» katagi: qabul qilinguncha jo'natuvchi sklad (server `canEditPrice`) ✏️ bilan o'zgartiradi. */
export default function TransferPriceCell({ record }: { record: any }) {
  const qc = useQueryClient()
  const { transfer } = narxlar(record)
  const [open, setOpen] = useState(false)
  const [v, setV] = useState<number | null>(transfer)
  const [busy, setBusy] = useState(false)
  const mumkin = !!record?.canEditPrice && permSync("transfers").canEdit
  const matn = transfer == null ? "—" : `$${normalizeCurrency(transfer)}`
  if (!mumkin) return <span data-testid="tr-price-cell">{matn}</span>
  const saqla = async () => {
    if (v == null || v < 0 || v > 1000000) { message.error(i18n.t("trPriceRange")); return }
    setBusy(true)
    try {
      await SET_TRANSFER_PRICE(record.id, Number(v))
      message.success(i18n.t("trPriceSaved"))
      setOpen(false)
      qc.invalidateQueries()
    } catch (e: any) {
      message.error(e?.response?.data?.message || i18n.t("cuSaveErr"))
    } finally {
      setBusy(false)
    }
  }
  return (
    <Popover
      trigger="click"
      visible={open}
      onVisibleChange={(o) => { setOpen(o); if (o) setV(transfer) }}
      title={i18n.t("trTransferPrice")}
      content={
        <div style={{ display: "flex", gap: 8 }} onClick={(e) => e.stopPropagation()}>
          <InputNumber autoFocus min={0} max={1000000} step={1} prefix="$" value={v as any} onChange={(x) => setV(x == null ? null : Number(x))} onPressEnter={saqla} style={{ width: 130 }} />
          <Button type="primary" loading={busy} onClick={saqla}>OK</Button>
        </div>
      }
    >
      <Button type="link" size="small" data-testid="tr-price-cell" style={{ padding: 0 }} onClick={(e) => e.stopPropagation()}>
        {matn} <EditOutlined />
      </Button>
    </Popover>
  )
}
